import util from '@bmp-vue/core/api/util'

const controller = 'Bureau'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  ConsultaSCR: function (dto) {
    return util.Axios.Post(controller + '/ConsultaSCR', dto)
  },
  GerarExcelSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcelSCR', dto)
  },
  GerarCSVSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarCSVSCR', dto)
  },
  GerarPDFSCR: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSCR', dto)
  },
  ConsultaDataBusca: function (dto) {
    return util.Axios.Post(controller + '/ConsultaDataBusca', dto)
  },
  GerarPDFDataBusca: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFDataBusca', dto)
  },
  ConsultaSPC: function (dto) {
    return util.Axios.Post(controller + '/ConsultaSPC', dto)
  },
  GerarPDFSPC: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSPC', dto)
  },
  ConsultaEmailAge: function (dto) {
    return util.Axios.Post(controller + '/ConsultaEmailage', dto)
  },
  GerarPDFEmailAge: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFEmailAge', dto)
  },
  NegativacoesSerasa (th, response) {
    th.model.SerasaConsultaDetalhe.push({
      NomeCredor: response?.creditorName || null,
      Valor: response?.amount || 0,
      DataOcorrencia: response?.occurrenceDate || null,
      Natureza: response?.legalNature || null,
      Contrato: response?.contractId || null,
      UF: response?.federalUnit || null,
      Cidade: response?.city || null,
      Banco: response?.bankName || null,
      Agencia: response?.bankAgencyId || null,
      Cheque: response?.checkNumber || null,
      QtdeCheques: response?.checkCount || null,
      Oficio: response?.officeNumber || null,
    });
  },
  FatosSerasa (th, response) {
    th.model.SerasaConsultaDetalhe.push({
      Valor: response?.amount || 0,
      DataOcorrencia: response?.occurrenceDate || null,
      Natureza: response?.legalNature || null,
      VaraJudicial: response?.civilCourt || null,
      Distribuidor: response?.distributor || null,
      UF: response?.federalUnit || null,
      Cidade: response?.city || null,
    });
  },
  RetornoSerasaPF (th, data) {
    th.model.SerasaConsultaDetalhe = []
    th.model.SerasaPF = {
      Nome: data.registration.consumerName || '----',
      DtNasc: data.registration.birthDate || '----',
      DocumentoFederal: data.registration.documentNumber || '----',
      EstadoCivil: data.partner || null,
      Situacao: data.registration.statusRegistration || '----',
      DtSituacao: data.registration.statusDate || '----',
      NomeMae: data.registration.motherName || '----',
      Score12Meses: data.score.score || '----',
      Score12MesesMSG: data.score.message || '----',
    }
    if (data.negativeData) {
      const negativeKeys = Object.keys(data?.negativeData)
      if (negativeKeys.length) {
        negativeKeys.forEach((item) => {
          const negativacoes = data.negativeData[item]?.[item + 'Response'];
          if (negativacoes && Array.isArray(negativacoes)) {
            negativacoes.forEach((response) => {
              this.NegativacoesSerasa(th, response)
            });
          }
        });
      }
    }
    if (data.facts) {
      const factKeys = Object.keys(data?.facts) || null;
      factKeys.forEach((item) => {
        const fatos = data.facts[item]?.[item + 'Response'];
        if (fatos && Array.isArray(fatos)) {
          fatos.forEach((response) => {
            this.FatosSerasa(th, response)
          });
        }
      });
    }
  },
  RetornoSerasaPJ (th, data) {
    const dataAtual = new Date().toISOString();
    th.model.SerasaConsultaDetalhe = []
    th.model.SerasaPJ = {
      NomeRzaoSocial: data.registration?.companyName || '----',
      DtFundacao: data.registration?.foundationDate || '----',
      DocumentoFederal: data.registration?.companyDocument || '----',
      UF: data.registration?.address.state || '----',
      Situacao: data.registration?.statusRegistration || '----',
      DtSituacao: data.registration?.statusDate || dataAtual,
      NomeMae: data.registration?.motherName || '----',
      Score: data?.score?.score || '----',
      Inadimplencia: data?.score?.defaultRate || '----',
      ScoreMensagem: data?.score?.message || '----',
    }
    if (data.negativeData) {
      const negativeKeys = Object.keys(data?.negativeData) || null;
      negativeKeys.forEach((item) => {
        const negativacoes = data.negativeData[item]?.[item + 'Response'];
        if (negativacoes && Array.isArray(negativacoes)) {
          negativacoes.forEach((response) => {
            this.NegativacoesSerasa(th, response)
          });
        }
      });
    }
    if (data.facts) {
      const factKeys = Object.keys(data?.facts) || null;
      factKeys.forEach((item) => {
        const fatos = data.facts[item]?.[item + 'Response'];
        if (fatos && Array.isArray(fatos)) {
          fatos.forEach((response) => {
            this.FatosSerasa(th, response)
          });
        }
      });
    }
  },
  FormataRetornoSerasa (th, data) {
    const parsedData = data.JSON ? JSON.parse(data.JSON)?.reports[0] : data.reports[0]
    const func = parsedData?.registration?.documentNumber?.length === 11
      ? this.RetornoSerasaPF
      : this.RetornoSerasaPJ

    func.call(this, th, parsedData);
  },
  ConsultaSerasa: function (th, dto) {
    const documento = dto.consulta.Documento
    const path = th.$aux.TipoPessoaEnum.PF === th.$api.Helper.RetornoTipoPessoa(documento) ? 'ConsultaSerasaCpf' : 'ConsultaSerasaCnpj';
    return th.$api.Multiplo.Post(path, dto).then((response) => {
      if (th.$api.UI.PostLoadData(response)) {
        return response
      }
      return th.$api.UI.ShowError('Erro Serasa', response.error)
    })
  },
  GerarPDFSerasa: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFSerasa', dto)
  },
  GerarPDFAllCheck: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDFAllCheck', dto)
  },
})
